export default "__VITE_ASSET__D3IfkaJd__"